import AssignUnassignButton from "./AssignUnassignButton";
import { isDriverReadyForDispatch } from "../../../utils";
import React from "react";

class ActionButtonRenderer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      command: this.getCommand(props),
      disabled: this.getDisableStatus(props, this.getCommand(props)),
    };
  }

  refresh = (props) => {
    this.setState({
      command: this.getCommand(props),
      disabled: this.getDisableStatus(props, this.getCommand(props)),
    });
    return true;
  };

  getCommand = (props) => {
    const selectedPickupRoutes = [
      ...new Set(
        props.api.selectedPickupsList?.map((pickup) => pickup.routeId)
      ),
    ];
    // get unique list of drivers for selected pickups
    if (
      selectedPickupRoutes.length === 1 &&
      selectedPickupRoutes.includes(props.data.routeId)
    ) {
      // If selected pickup belong same driver show unassign
      return "Unassign";
    } else if (!Boolean(props.data?.dispatchId)) {
      return "Dispatch";
    } else if (selectedPickupRoutes.filter(Boolean).length === 0) {
      // if none of the selected pickup have drivers show Assign
      return "Assign";
    } else {
      return "Reassign";
    }
  };

  shouldComponentUpdate(_nextProps, nextState) {
    return (
      this.state.command !== nextState.command ||
      this.state.disabled !== nextState.disabled
    );
  }

  getDisableStatus = (props, command) => {
    const isPickupSelected = props.api.selectedPickupsList?.length > 0;
    const enableDispatchDriver = props.context.enableDispatchDriver;
    const isCompletedOrFuturePickup = props.api.selectedPickupsList?.some(
      (pickup) =>
        pickup.isCompleted ||
        pickup.isFuture ||
        pickup.isVoided ||
        pickup.isMissed
    );

    return command === "Dispatch"
      ? !enableDispatchDriver &&
          !isDriverReadyForDispatch(
            this.props.data.driverClockedInTime,
            this.props.data.isCompanyDriver
          )
      : !isPickupSelected || isCompletedOrFuturePickup;
  };

  render() {
    const { command, disabled } = this.state;
    return (
      <div>
        <AssignUnassignButton
          variant="outlined"
          color="primary"
          disabled={disabled}
          onClick={() =>
            this.props.api.runCommand(command, {
              driver: this.props.data,
            })
          }
          data-automationid={command}
        >
          {command}
        </AssignUnassignButton>
      </div>
    );
  }
}

export default ActionButtonRenderer;
